import { render, staticRenderFns } from "./detailsNewContent.vue?vue&type=template&id=fb4664d6&scoped=true&"
import script from "./detailsNewContent.vue?vue&type=script&lang=ts&"
export * from "./detailsNewContent.vue?vue&type=script&lang=ts&"
import style0 from "./detailsNewContent.vue?vue&type=style&index=0&id=fb4664d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb4664d6",
  null
  
)

export default component.exports